/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';

export default class Status extends Model {
	name() {
		return Model.attribute<string>('name').call(this);
	}
	icon() {
		return Model.attribute<string>('icon').call(this);
	}
}
